import { axios } from "..";
import { MyWSGGroupData } from "../interfaces/models/IGroup";

export type FirmGroupStatistics = {
  distinctOpenGroups: number;
  distinctPrivateGroups: number;
  distinctOpenGroupsParticipants: number;
  distinctPrivateGroupsParticipants: number;
};

export const getFirmGroupStatistics = async (
  firmId: string,
): Promise<FirmGroupStatistics> => {
  const normalizedFirmId = String(firmId || "").trim();
  if (!normalizedFirmId) {
    return {
      distinctOpenGroups: 0,
      distinctPrivateGroups: 0,
      distinctOpenGroupsParticipants: 0,
      distinctPrivateGroupsParticipants: 0,
    };
  }

  try {
    const params = new URLSearchParams({ firmId: normalizedFirmId });
    const response = await axios.Get(`/firmGroupStatistics?${params.toString()}`);
    const data = response?.data;
    if (!data || typeof data !== "object") {
      return {
        distinctOpenGroups: 0,
        distinctPrivateGroups: 0,
        distinctOpenGroupsParticipants: 0,
        distinctPrivateGroupsParticipants: 0,
      };
    }

    return {
      distinctOpenGroups: Number(data.distinctOpenGroups) || 0,
      distinctPrivateGroups: Number(data.distinctPrivateGroups) || 0,
      distinctOpenGroupsParticipants:
        Number(data.distinctOpenGroupsParticipants) || 0,
      distinctPrivateGroupsParticipants:
        Number(data.distinctPrivateGroupsParticipants) || 0,
    };
  } catch (error) {
    console.error("Error fetching firm group statistics:", error);
    return {
      distinctOpenGroups: 0,
      distinctPrivateGroups: 0,
      distinctOpenGroupsParticipants: 0,
      distinctPrivateGroupsParticipants: 0,
    };
  }
};

export const getGroupsByPersonIdWithDetails = async (personId: string): Promise<MyWSGGroupData[]> => {
  try {
    const params = new URLSearchParams({ personId });
    const response = await axios.Get(`/myWSGGroups?${params.toString()}`);
    return response?.data ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

export const getGroupById = async (id: string): Promise<any> => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({id: {value: id, comparisonType: 'EQUAL'}}));
    const response = await axios.Get(`/group?${params.toString()}`);
    return response?.data?.[0] ?? null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export const getAllGroups = async (): Promise<any[]> => {
  try {
    const response = await axios.Get('/group');
    return response?.data ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

export const markMessageAsViewed = async (personId: string, messageId: string, messageTpye: string): Promise<boolean> => {
  try {
    const response = await axios.PutDataIntoModel(`/person?action=markMessageAsViewed`, {
      personId,
      messageId,
      messageTpye
    });
    return response?.data?.success ?? false;
  } catch (error) {
    console.error('Error marking message as viewed:', error);
    return false;
  }
}
